export default __webpack_public_path__ + "static/media/agarwal.0a13c0ca.mp4";